import './index.css'
import * as React from 'react'
import { ComingSoon } from '../../components/ComingSoon'
import { ContentHeader, PaddingBox, PageBreadcrumb, PageTitle, TabHeader } from '../../components/Wrapper'

export function Chat() {
  return (
    <div className='dash-board-page'>
      <ContentHeader white={false} border>
        <PageBreadcrumb path={['Home', 'Chat']} />
        <TabHeader padding={false}>
          <PageTitle text='Chat' />
        </TabHeader>
      </ContentHeader>
      <PaddingBox>
        <ComingSoon
          title='Chat is coming soon'
          description="You'll be able to message patients directly from here once this feature is ready."
        />
      </PaddingBox>
    </div>
  )
}
